/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PaginatedSupportArticleList,
  PaginatedSupportCustomerRowList,
  PaginatedSupportMacroList,
  PaginatedSupportRefundList,
  PaginatedSupportTicketList,
  PatchedSupportArticleRequest,
  PatchedSupportConfigPatchRequest,
  PatchedSupportMacroRequest,
  SupportArticle,
  SupportArticleRequest,
  SupportArticlesListParams,
  SupportArticlesSearchRetrieveParams,
  SupportAssignRequest,
  SupportConfig,
  SupportCreditsRequest,
  SupportCsatRequest,
  SupportCustomerCard,
  SupportCustomersListParams,
  SupportDashboard,
  SupportDecideRequest,
  SupportDetailsRequest,
  SupportExtendRequest,
  SupportFromConversationRequest,
  SupportInvoiceRefRequest,
  SupportKnowledgeSearch,
  SupportLearnersListParams,
  SupportMacro,
  SupportMacroRequest,
  SupportMacrosListParams,
  SupportMergeRequest,
  SupportMyOptions,
  SupportMyReplyRequest,
  SupportMyTicket,
  SupportMyTicketCreateRequest,
  SupportMyTicketDetail,
  SupportPriorityRequest,
  SupportPublicCsat,
  SupportRefund,
  SupportRefundCreateRequest,
  SupportRefundsListParams,
  SupportReplyRequest,
  SupportReviewForRequest,
  SupportStatusRequest,
  SupportSummary,
  SupportTagsRequest,
  SupportTicketCreateRequest,
  SupportTicketDetail,
  SupportTicketRefRequest,
  SupportTicketsDashboardRetrieveParams,
  SupportTicketsListParams
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Internal knowledge base. Deleting = unpublishing (nothing is deleted).
 */
export type supportArticlesListResponse200 = {
  data: PaginatedSupportArticleList
  status: 200
}
    
export type supportArticlesListResponseSuccess = (supportArticlesListResponse200) & {
  headers: Headers;
};
;

export type supportArticlesListResponse = (supportArticlesListResponseSuccess)

export const getSupportArticlesListUrl = (params?: SupportArticlesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/articles/?${stringifiedParams}` : `/api/v1/support/articles/`
}

export const supportArticlesList = async (params?: SupportArticlesListParams, options?: RequestInit): Promise<supportArticlesListResponse> => {
  
  return apiFetch<supportArticlesListResponse>(getSupportArticlesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportArticlesListQueryKey = (params?: SupportArticlesListParams,) => {
    return [
    `/api/v1/support/articles/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportArticlesListQueryOptions = <TData = Awaited<ReturnType<typeof supportArticlesList>>, TError = unknown>(params?: SupportArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportArticlesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportArticlesList>>> = ({ signal }) => supportArticlesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportArticlesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportArticlesListQueryResult = NonNullable<Awaited<ReturnType<typeof supportArticlesList>>>
export type SupportArticlesListQueryError = unknown


export function useSupportArticlesList<TData = Awaited<ReturnType<typeof supportArticlesList>>, TError = unknown>(
 params: undefined |  SupportArticlesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportArticlesList>>,
          TError,
          Awaited<ReturnType<typeof supportArticlesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportArticlesList<TData = Awaited<ReturnType<typeof supportArticlesList>>, TError = unknown>(
 params?: SupportArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportArticlesList>>,
          TError,
          Awaited<ReturnType<typeof supportArticlesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportArticlesList<TData = Awaited<ReturnType<typeof supportArticlesList>>, TError = unknown>(
 params?: SupportArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportArticlesList<TData = Awaited<ReturnType<typeof supportArticlesList>>, TError = unknown>(
 params?: SupportArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportArticlesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Internal knowledge base. Deleting = unpublishing (nothing is deleted).
 */
export type supportArticlesCreateResponse201 = {
  data: SupportArticle
  status: 201
}
    
export type supportArticlesCreateResponseSuccess = (supportArticlesCreateResponse201) & {
  headers: Headers;
};
;

export type supportArticlesCreateResponse = (supportArticlesCreateResponseSuccess)

export const getSupportArticlesCreateUrl = () => {


  

  return `/api/v1/support/articles/`
}

export const supportArticlesCreate = async (supportArticleRequest: SupportArticleRequest, options?: RequestInit): Promise<supportArticlesCreateResponse> => {
  
  return apiFetch<supportArticlesCreateResponse>(getSupportArticlesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportArticleRequest,)
  }
);}




export const getSupportArticlesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportArticlesCreate>>, TError,{data: SupportArticleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportArticlesCreate>>, TError,{data: SupportArticleRequest}, TContext> => {

const mutationKey = ['supportArticlesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportArticlesCreate>>, {data: SupportArticleRequest}> = (props) => {
          const {data} = props ?? {};

          return  supportArticlesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportArticlesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportArticlesCreate>>>
    export type SupportArticlesCreateMutationBody = SupportArticleRequest
    export type SupportArticlesCreateMutationError = unknown

    export const useSupportArticlesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportArticlesCreate>>, TError,{data: SupportArticleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportArticlesCreate>>,
        TError,
        {data: SupportArticleRequest},
        TContext
      > => {

      const mutationOptions = getSupportArticlesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Internal knowledge base. Deleting = unpublishing (nothing is deleted).
 */
export type supportArticlesRetrieveResponse200 = {
  data: SupportArticle
  status: 200
}
    
export type supportArticlesRetrieveResponseSuccess = (supportArticlesRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportArticlesRetrieveResponse = (supportArticlesRetrieveResponseSuccess)

export const getSupportArticlesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/support/articles/${id}/`
}

export const supportArticlesRetrieve = async (id: string, options?: RequestInit): Promise<supportArticlesRetrieveResponse> => {
  
  return apiFetch<supportArticlesRetrieveResponse>(getSupportArticlesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportArticlesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/support/articles/${id}/`
    ] as const;
    }

    
export const getSupportArticlesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportArticlesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportArticlesRetrieve>>> = ({ signal }) => supportArticlesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportArticlesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportArticlesRetrieve>>>
export type SupportArticlesRetrieveQueryError = unknown


export function useSupportArticlesRetrieve<TData = Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportArticlesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportArticlesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportArticlesRetrieve<TData = Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportArticlesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportArticlesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportArticlesRetrieve<TData = Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportArticlesRetrieve<TData = Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportArticlesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Internal knowledge base. Deleting = unpublishing (nothing is deleted).
 */
export type supportArticlesPartialUpdateResponse200 = {
  data: SupportArticle
  status: 200
}
    
export type supportArticlesPartialUpdateResponseSuccess = (supportArticlesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type supportArticlesPartialUpdateResponse = (supportArticlesPartialUpdateResponseSuccess)

export const getSupportArticlesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/support/articles/${id}/`
}

export const supportArticlesPartialUpdate = async (id: string,
    patchedSupportArticleRequest: PatchedSupportArticleRequest, options?: RequestInit): Promise<supportArticlesPartialUpdateResponse> => {
  
  return apiFetch<supportArticlesPartialUpdateResponse>(getSupportArticlesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedSupportArticleRequest,)
  }
);}




export const getSupportArticlesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportArticlesPartialUpdate>>, TError,{id: string;data: PatchedSupportArticleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportArticlesPartialUpdate>>, TError,{id: string;data: PatchedSupportArticleRequest}, TContext> => {

const mutationKey = ['supportArticlesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportArticlesPartialUpdate>>, {id: string;data: PatchedSupportArticleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportArticlesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportArticlesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof supportArticlesPartialUpdate>>>
    export type SupportArticlesPartialUpdateMutationBody = PatchedSupportArticleRequest
    export type SupportArticlesPartialUpdateMutationError = unknown

    export const useSupportArticlesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportArticlesPartialUpdate>>, TError,{id: string;data: PatchedSupportArticleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportArticlesPartialUpdate>>,
        TError,
        {id: string;data: PatchedSupportArticleRequest},
        TContext
      > => {

      const mutationOptions = getSupportArticlesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Articles AND the sections of the published bible that match (read-only).
 */
export type supportArticlesSearchRetrieveResponse200 = {
  data: SupportKnowledgeSearch
  status: 200
}
    
export type supportArticlesSearchRetrieveResponseSuccess = (supportArticlesSearchRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportArticlesSearchRetrieveResponse = (supportArticlesSearchRetrieveResponseSuccess)

export const getSupportArticlesSearchRetrieveUrl = (params?: SupportArticlesSearchRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/articles/search/?${stringifiedParams}` : `/api/v1/support/articles/search/`
}

export const supportArticlesSearchRetrieve = async (params?: SupportArticlesSearchRetrieveParams, options?: RequestInit): Promise<supportArticlesSearchRetrieveResponse> => {
  
  return apiFetch<supportArticlesSearchRetrieveResponse>(getSupportArticlesSearchRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportArticlesSearchRetrieveQueryKey = (params?: SupportArticlesSearchRetrieveParams,) => {
    return [
    `/api/v1/support/articles/search/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportArticlesSearchRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError = unknown>(params?: SupportArticlesSearchRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportArticlesSearchRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>> = ({ signal }) => supportArticlesSearchRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportArticlesSearchRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>>
export type SupportArticlesSearchRetrieveQueryError = unknown


export function useSupportArticlesSearchRetrieve<TData = Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError = unknown>(
 params: undefined |  SupportArticlesSearchRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportArticlesSearchRetrieve<TData = Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError = unknown>(
 params?: SupportArticlesSearchRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportArticlesSearchRetrieve<TData = Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError = unknown>(
 params?: SupportArticlesSearchRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportArticlesSearchRetrieve<TData = Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError = unknown>(
 params?: SupportArticlesSearchRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportArticlesSearchRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportArticlesSearchRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type supportConfigRetrieveResponse200 = {
  data: SupportConfig
  status: 200
}
    
export type supportConfigRetrieveResponseSuccess = (supportConfigRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportConfigRetrieveResponse = (supportConfigRetrieveResponseSuccess)

export const getSupportConfigRetrieveUrl = () => {


  

  return `/api/v1/support/config/`
}

export const supportConfigRetrieve = async ( options?: RequestInit): Promise<supportConfigRetrieveResponse> => {
  
  return apiFetch<supportConfigRetrieveResponse>(getSupportConfigRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportConfigRetrieveQueryKey = () => {
    return [
    `/api/v1/support/config/`
    ] as const;
    }

    
export const getSupportConfigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportConfigRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportConfigRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportConfigRetrieve>>> = ({ signal }) => supportConfigRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportConfigRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportConfigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportConfigRetrieve>>>
export type SupportConfigRetrieveQueryError = unknown


export function useSupportConfigRetrieve<TData = Awaited<ReturnType<typeof supportConfigRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportConfigRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportConfigRetrieve<TData = Awaited<ReturnType<typeof supportConfigRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportConfigRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportConfigRetrieve<TData = Awaited<ReturnType<typeof supportConfigRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportConfigRetrieve<TData = Awaited<ReturnType<typeof supportConfigRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportConfigRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type supportConfigPartialUpdateResponse200 = {
  data: SupportConfig
  status: 200
}
    
export type supportConfigPartialUpdateResponseSuccess = (supportConfigPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type supportConfigPartialUpdateResponse = (supportConfigPartialUpdateResponseSuccess)

export const getSupportConfigPartialUpdateUrl = () => {


  

  return `/api/v1/support/config/`
}

export const supportConfigPartialUpdate = async (patchedSupportConfigPatchRequest: PatchedSupportConfigPatchRequest, options?: RequestInit): Promise<supportConfigPartialUpdateResponse> => {
  
  return apiFetch<supportConfigPartialUpdateResponse>(getSupportConfigPartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedSupportConfigPatchRequest,)
  }
);}




export const getSupportConfigPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportConfigPartialUpdate>>, TError,{data: PatchedSupportConfigPatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportConfigPartialUpdate>>, TError,{data: PatchedSupportConfigPatchRequest}, TContext> => {

const mutationKey = ['supportConfigPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportConfigPartialUpdate>>, {data: PatchedSupportConfigPatchRequest}> = (props) => {
          const {data} = props ?? {};

          return  supportConfigPartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportConfigPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof supportConfigPartialUpdate>>>
    export type SupportConfigPartialUpdateMutationBody = PatchedSupportConfigPatchRequest
    export type SupportConfigPartialUpdateMutationError = unknown

    export const useSupportConfigPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportConfigPartialUpdate>>, TError,{data: PatchedSupportConfigPatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportConfigPartialUpdate>>,
        TError,
        {data: PatchedSupportConfigPatchRequest},
        TContext
      > => {

      const mutationOptions = getSupportConfigPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The customer cards of the support (CRM contacts), read-only, plus the logged actions.
 */
export type supportCustomersListResponse200 = {
  data: PaginatedSupportCustomerRowList
  status: 200
}
    
export type supportCustomersListResponseSuccess = (supportCustomersListResponse200) & {
  headers: Headers;
};
;

export type supportCustomersListResponse = (supportCustomersListResponseSuccess)

export const getSupportCustomersListUrl = (params?: SupportCustomersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/customers/?${stringifiedParams}` : `/api/v1/support/customers/`
}

export const supportCustomersList = async (params?: SupportCustomersListParams, options?: RequestInit): Promise<supportCustomersListResponse> => {
  
  return apiFetch<supportCustomersListResponse>(getSupportCustomersListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportCustomersListQueryKey = (params?: SupportCustomersListParams,) => {
    return [
    `/api/v1/support/customers/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportCustomersListQueryOptions = <TData = Awaited<ReturnType<typeof supportCustomersList>>, TError = unknown>(params?: SupportCustomersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportCustomersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportCustomersList>>> = ({ signal }) => supportCustomersList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportCustomersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportCustomersListQueryResult = NonNullable<Awaited<ReturnType<typeof supportCustomersList>>>
export type SupportCustomersListQueryError = unknown


export function useSupportCustomersList<TData = Awaited<ReturnType<typeof supportCustomersList>>, TError = unknown>(
 params: undefined |  SupportCustomersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportCustomersList>>,
          TError,
          Awaited<ReturnType<typeof supportCustomersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCustomersList<TData = Awaited<ReturnType<typeof supportCustomersList>>, TError = unknown>(
 params?: SupportCustomersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportCustomersList>>,
          TError,
          Awaited<ReturnType<typeof supportCustomersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCustomersList<TData = Awaited<ReturnType<typeof supportCustomersList>>, TError = unknown>(
 params?: SupportCustomersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportCustomersList<TData = Awaited<ReturnType<typeof supportCustomersList>>, TError = unknown>(
 params?: SupportCustomersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportCustomersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The customer cards of the support (CRM contacts), read-only, plus the logged actions.
 */
export type supportCustomersRetrieveResponse200 = {
  data: SupportCustomerCard
  status: 200
}
    
export type supportCustomersRetrieveResponseSuccess = (supportCustomersRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportCustomersRetrieveResponse = (supportCustomersRetrieveResponseSuccess)

export const getSupportCustomersRetrieveUrl = (id: string,) => {


  

  return `/api/v1/support/customers/${id}/`
}

export const supportCustomersRetrieve = async (id: string, options?: RequestInit): Promise<supportCustomersRetrieveResponse> => {
  
  return apiFetch<supportCustomersRetrieveResponse>(getSupportCustomersRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportCustomersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/support/customers/${id}/`
    ] as const;
    }

    
export const getSupportCustomersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportCustomersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportCustomersRetrieve>>> = ({ signal }) => supportCustomersRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportCustomersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportCustomersRetrieve>>>
export type SupportCustomersRetrieveQueryError = unknown


export function useSupportCustomersRetrieve<TData = Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportCustomersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportCustomersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCustomersRetrieve<TData = Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportCustomersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportCustomersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportCustomersRetrieve<TData = Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportCustomersRetrieve<TData = Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportCustomersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportCustomersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The customer cards of the support (CRM contacts), read-only, plus the logged actions.
 */
export type supportCustomersDetailsCreateResponse200 = {
  data: SupportCustomerCard
  status: 200
}
    
export type supportCustomersDetailsCreateResponseSuccess = (supportCustomersDetailsCreateResponse200) & {
  headers: Headers;
};
;

export type supportCustomersDetailsCreateResponse = (supportCustomersDetailsCreateResponseSuccess)

export const getSupportCustomersDetailsCreateUrl = (id: string,) => {


  

  return `/api/v1/support/customers/${id}/details/`
}

export const supportCustomersDetailsCreate = async (id: string,
    supportDetailsRequest: SupportDetailsRequest, options?: RequestInit): Promise<supportCustomersDetailsCreateResponse> => {
  
  return apiFetch<supportCustomersDetailsCreateResponse>(getSupportCustomersDetailsCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportDetailsRequest,)
  }
);}




export const getSupportCustomersDetailsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportCustomersDetailsCreate>>, TError,{id: string;data: SupportDetailsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportCustomersDetailsCreate>>, TError,{id: string;data: SupportDetailsRequest}, TContext> => {

const mutationKey = ['supportCustomersDetailsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportCustomersDetailsCreate>>, {id: string;data: SupportDetailsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportCustomersDetailsCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportCustomersDetailsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportCustomersDetailsCreate>>>
    export type SupportCustomersDetailsCreateMutationBody = SupportDetailsRequest
    export type SupportCustomersDetailsCreateMutationError = unknown

    export const useSupportCustomersDetailsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportCustomersDetailsCreate>>, TError,{id: string;data: SupportDetailsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportCustomersDetailsCreate>>,
        TError,
        {id: string;data: SupportDetailsRequest},
        TContext
      > => {

      const mutationOptions = getSupportCustomersDetailsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Sends again an invoice (link to pay or download) or a receipt of THIS customer.
 */
export type supportCustomersResendDocumentCreateResponse202 = {
  data: void
  status: 202
}
    
export type supportCustomersResendDocumentCreateResponseSuccess = (supportCustomersResendDocumentCreateResponse202) & {
  headers: Headers;
};
;

export type supportCustomersResendDocumentCreateResponse = (supportCustomersResendDocumentCreateResponseSuccess)

export const getSupportCustomersResendDocumentCreateUrl = (id: string,) => {


  

  return `/api/v1/support/customers/${id}/resend-document/`
}

export const supportCustomersResendDocumentCreate = async (id: string,
    supportInvoiceRefRequest: SupportInvoiceRefRequest, options?: RequestInit): Promise<supportCustomersResendDocumentCreateResponse> => {
  
  return apiFetch<supportCustomersResendDocumentCreateResponse>(getSupportCustomersResendDocumentCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportInvoiceRefRequest,)
  }
);}




export const getSupportCustomersResendDocumentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportCustomersResendDocumentCreate>>, TError,{id: string;data: SupportInvoiceRefRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportCustomersResendDocumentCreate>>, TError,{id: string;data: SupportInvoiceRefRequest}, TContext> => {

const mutationKey = ['supportCustomersResendDocumentCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportCustomersResendDocumentCreate>>, {id: string;data: SupportInvoiceRefRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportCustomersResendDocumentCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportCustomersResendDocumentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportCustomersResendDocumentCreate>>>
    export type SupportCustomersResendDocumentCreateMutationBody = SupportInvoiceRefRequest
    export type SupportCustomersResendDocumentCreateMutationError = unknown

    export const useSupportCustomersResendDocumentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportCustomersResendDocumentCreate>>, TError,{id: string;data: SupportInvoiceRefRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportCustomersResendDocumentCreate>>,
        TError,
        {id: string;data: SupportInvoiceRefRequest},
        TContext
      > => {

      const mutationOptions = getSupportCustomersResendDocumentCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The Academy students seen by the support, with the capped resolution actions.
 */
export type supportLearnersListResponse200 = {
  data: PaginatedSupportCustomerRowList
  status: 200
}
    
export type supportLearnersListResponseSuccess = (supportLearnersListResponse200) & {
  headers: Headers;
};
;

export type supportLearnersListResponse = (supportLearnersListResponseSuccess)

export const getSupportLearnersListUrl = (params?: SupportLearnersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/learners/?${stringifiedParams}` : `/api/v1/support/learners/`
}

export const supportLearnersList = async (params?: SupportLearnersListParams, options?: RequestInit): Promise<supportLearnersListResponse> => {
  
  return apiFetch<supportLearnersListResponse>(getSupportLearnersListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportLearnersListQueryKey = (params?: SupportLearnersListParams,) => {
    return [
    `/api/v1/support/learners/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportLearnersListQueryOptions = <TData = Awaited<ReturnType<typeof supportLearnersList>>, TError = unknown>(params?: SupportLearnersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportLearnersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportLearnersList>>> = ({ signal }) => supportLearnersList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportLearnersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportLearnersListQueryResult = NonNullable<Awaited<ReturnType<typeof supportLearnersList>>>
export type SupportLearnersListQueryError = unknown


export function useSupportLearnersList<TData = Awaited<ReturnType<typeof supportLearnersList>>, TError = unknown>(
 params: undefined |  SupportLearnersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportLearnersList>>,
          TError,
          Awaited<ReturnType<typeof supportLearnersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLearnersList<TData = Awaited<ReturnType<typeof supportLearnersList>>, TError = unknown>(
 params?: SupportLearnersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportLearnersList>>,
          TError,
          Awaited<ReturnType<typeof supportLearnersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLearnersList<TData = Awaited<ReturnType<typeof supportLearnersList>>, TError = unknown>(
 params?: SupportLearnersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportLearnersList<TData = Awaited<ReturnType<typeof supportLearnersList>>, TError = unknown>(
 params?: SupportLearnersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportLearnersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The Academy students seen by the support, with the capped resolution actions.
 */
export type supportLearnersRetrieveResponse200 = {
  data: SupportCustomerCard
  status: 200
}
    
export type supportLearnersRetrieveResponseSuccess = (supportLearnersRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportLearnersRetrieveResponse = (supportLearnersRetrieveResponseSuccess)

export const getSupportLearnersRetrieveUrl = (id: string,) => {


  

  return `/api/v1/support/learners/${id}/`
}

export const supportLearnersRetrieve = async (id: string, options?: RequestInit): Promise<supportLearnersRetrieveResponse> => {
  
  return apiFetch<supportLearnersRetrieveResponse>(getSupportLearnersRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportLearnersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/support/learners/${id}/`
    ] as const;
    }

    
export const getSupportLearnersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportLearnersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportLearnersRetrieve>>> = ({ signal }) => supportLearnersRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportLearnersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportLearnersRetrieve>>>
export type SupportLearnersRetrieveQueryError = unknown


export function useSupportLearnersRetrieve<TData = Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportLearnersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportLearnersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLearnersRetrieve<TData = Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportLearnersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportLearnersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportLearnersRetrieve<TData = Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportLearnersRetrieve<TData = Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportLearnersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportLearnersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The Academy students seen by the support, with the capped resolution actions.
 */
export type supportLearnersCreditsCreateResponse200 = {
  data: SupportCustomerCard
  status: 200
}
    
export type supportLearnersCreditsCreateResponseSuccess = (supportLearnersCreditsCreateResponse200) & {
  headers: Headers;
};
;

export type supportLearnersCreditsCreateResponse = (supportLearnersCreditsCreateResponseSuccess)

export const getSupportLearnersCreditsCreateUrl = (id: string,) => {


  

  return `/api/v1/support/learners/${id}/credits/`
}

export const supportLearnersCreditsCreate = async (id: string,
    supportCreditsRequest: SupportCreditsRequest, options?: RequestInit): Promise<supportLearnersCreditsCreateResponse> => {
  
  return apiFetch<supportLearnersCreditsCreateResponse>(getSupportLearnersCreditsCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportCreditsRequest,)
  }
);}




export const getSupportLearnersCreditsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersCreditsCreate>>, TError,{id: string;data: SupportCreditsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportLearnersCreditsCreate>>, TError,{id: string;data: SupportCreditsRequest}, TContext> => {

const mutationKey = ['supportLearnersCreditsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportLearnersCreditsCreate>>, {id: string;data: SupportCreditsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportLearnersCreditsCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportLearnersCreditsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportLearnersCreditsCreate>>>
    export type SupportLearnersCreditsCreateMutationBody = SupportCreditsRequest
    export type SupportLearnersCreditsCreateMutationError = unknown

    export const useSupportLearnersCreditsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersCreditsCreate>>, TError,{id: string;data: SupportCreditsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportLearnersCreditsCreate>>,
        TError,
        {id: string;data: SupportCreditsRequest},
        TContext
      > => {

      const mutationOptions = getSupportLearnersCreditsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The Academy students seen by the support, with the capped resolution actions.
 */
export type supportLearnersDetailsCreateResponse200 = {
  data: SupportCustomerCard
  status: 200
}
    
export type supportLearnersDetailsCreateResponseSuccess = (supportLearnersDetailsCreateResponse200) & {
  headers: Headers;
};
;

export type supportLearnersDetailsCreateResponse = (supportLearnersDetailsCreateResponseSuccess)

export const getSupportLearnersDetailsCreateUrl = (id: string,) => {


  

  return `/api/v1/support/learners/${id}/details/`
}

export const supportLearnersDetailsCreate = async (id: string,
    supportDetailsRequest: SupportDetailsRequest, options?: RequestInit): Promise<supportLearnersDetailsCreateResponse> => {
  
  return apiFetch<supportLearnersDetailsCreateResponse>(getSupportLearnersDetailsCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportDetailsRequest,)
  }
);}




export const getSupportLearnersDetailsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersDetailsCreate>>, TError,{id: string;data: SupportDetailsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportLearnersDetailsCreate>>, TError,{id: string;data: SupportDetailsRequest}, TContext> => {

const mutationKey = ['supportLearnersDetailsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportLearnersDetailsCreate>>, {id: string;data: SupportDetailsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportLearnersDetailsCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportLearnersDetailsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportLearnersDetailsCreate>>>
    export type SupportLearnersDetailsCreateMutationBody = SupportDetailsRequest
    export type SupportLearnersDetailsCreateMutationError = unknown

    export const useSupportLearnersDetailsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersDetailsCreate>>, TError,{id: string;data: SupportDetailsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportLearnersDetailsCreate>>,
        TError,
        {id: string;data: SupportDetailsRequest},
        TContext
      > => {

      const mutationOptions = getSupportLearnersDetailsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The Academy students seen by the support, with the capped resolution actions.
 */
export type supportLearnersExtendCreateResponse200 = {
  data: SupportCustomerCard
  status: 200
}
    
export type supportLearnersExtendCreateResponseSuccess = (supportLearnersExtendCreateResponse200) & {
  headers: Headers;
};
;

export type supportLearnersExtendCreateResponse = (supportLearnersExtendCreateResponseSuccess)

export const getSupportLearnersExtendCreateUrl = (id: string,) => {


  

  return `/api/v1/support/learners/${id}/extend/`
}

export const supportLearnersExtendCreate = async (id: string,
    supportExtendRequest: SupportExtendRequest, options?: RequestInit): Promise<supportLearnersExtendCreateResponse> => {
  
  return apiFetch<supportLearnersExtendCreateResponse>(getSupportLearnersExtendCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportExtendRequest,)
  }
);}




export const getSupportLearnersExtendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersExtendCreate>>, TError,{id: string;data: SupportExtendRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportLearnersExtendCreate>>, TError,{id: string;data: SupportExtendRequest}, TContext> => {

const mutationKey = ['supportLearnersExtendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportLearnersExtendCreate>>, {id: string;data: SupportExtendRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportLearnersExtendCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportLearnersExtendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportLearnersExtendCreate>>>
    export type SupportLearnersExtendCreateMutationBody = SupportExtendRequest
    export type SupportLearnersExtendCreateMutationError = unknown

    export const useSupportLearnersExtendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersExtendCreate>>, TError,{id: string;data: SupportExtendRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportLearnersExtendCreate>>,
        TError,
        {id: string;data: SupportExtendRequest},
        TContext
      > => {

      const mutationOptions = getSupportLearnersExtendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The Academy students seen by the support, with the capped resolution actions.
 */
export type supportLearnersResendAccessCreateResponse202 = {
  data: SupportCustomerCard
  status: 202
}
    
export type supportLearnersResendAccessCreateResponseSuccess = (supportLearnersResendAccessCreateResponse202) & {
  headers: Headers;
};
;

export type supportLearnersResendAccessCreateResponse = (supportLearnersResendAccessCreateResponseSuccess)

export const getSupportLearnersResendAccessCreateUrl = (id: string,) => {


  

  return `/api/v1/support/learners/${id}/resend-access/`
}

export const supportLearnersResendAccessCreate = async (id: string,
    supportTicketRefRequest: SupportTicketRefRequest, options?: RequestInit): Promise<supportLearnersResendAccessCreateResponse> => {
  
  return apiFetch<supportLearnersResendAccessCreateResponse>(getSupportLearnersResendAccessCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportTicketRefRequest,)
  }
);}




export const getSupportLearnersResendAccessCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersResendAccessCreate>>, TError,{id: string;data: SupportTicketRefRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportLearnersResendAccessCreate>>, TError,{id: string;data: SupportTicketRefRequest}, TContext> => {

const mutationKey = ['supportLearnersResendAccessCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportLearnersResendAccessCreate>>, {id: string;data: SupportTicketRefRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportLearnersResendAccessCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportLearnersResendAccessCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportLearnersResendAccessCreate>>>
    export type SupportLearnersResendAccessCreateMutationBody = SupportTicketRefRequest
    export type SupportLearnersResendAccessCreateMutationError = unknown

    export const useSupportLearnersResendAccessCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersResendAccessCreate>>, TError,{id: string;data: SupportTicketRefRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportLearnersResendAccessCreate>>,
        TError,
        {id: string;data: SupportTicketRefRequest},
        TContext
      > => {

      const mutationOptions = getSupportLearnersResendAccessCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The Academy students seen by the support, with the capped resolution actions.
 */
export type supportLearnersTrainerReviewCreateResponse201 = {
  data: SupportCustomerCard
  status: 201
}
    
export type supportLearnersTrainerReviewCreateResponseSuccess = (supportLearnersTrainerReviewCreateResponse201) & {
  headers: Headers;
};
;

export type supportLearnersTrainerReviewCreateResponse = (supportLearnersTrainerReviewCreateResponseSuccess)

export const getSupportLearnersTrainerReviewCreateUrl = (id: string,) => {


  

  return `/api/v1/support/learners/${id}/trainer-review/`
}

export const supportLearnersTrainerReviewCreate = async (id: string,
    supportReviewForRequest: SupportReviewForRequest, options?: RequestInit): Promise<supportLearnersTrainerReviewCreateResponse> => {
  
  return apiFetch<supportLearnersTrainerReviewCreateResponse>(getSupportLearnersTrainerReviewCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportReviewForRequest,)
  }
);}




export const getSupportLearnersTrainerReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersTrainerReviewCreate>>, TError,{id: string;data: SupportReviewForRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportLearnersTrainerReviewCreate>>, TError,{id: string;data: SupportReviewForRequest}, TContext> => {

const mutationKey = ['supportLearnersTrainerReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportLearnersTrainerReviewCreate>>, {id: string;data: SupportReviewForRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportLearnersTrainerReviewCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportLearnersTrainerReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportLearnersTrainerReviewCreate>>>
    export type SupportLearnersTrainerReviewCreateMutationBody = SupportReviewForRequest
    export type SupportLearnersTrainerReviewCreateMutationError = unknown

    export const useSupportLearnersTrainerReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersTrainerReviewCreate>>, TError,{id: string;data: SupportReviewForRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportLearnersTrainerReviewCreate>>,
        TError,
        {id: string;data: SupportReviewForRequest},
        TContext
      > => {

      const mutationOptions = getSupportLearnersTrainerReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The Academy students seen by the support, with the capped resolution actions.
 */
export type supportLearnersUnblockCreateResponse200 = {
  data: SupportCustomerCard
  status: 200
}
    
export type supportLearnersUnblockCreateResponseSuccess = (supportLearnersUnblockCreateResponse200) & {
  headers: Headers;
};
;

export type supportLearnersUnblockCreateResponse = (supportLearnersUnblockCreateResponseSuccess)

export const getSupportLearnersUnblockCreateUrl = (id: string,) => {


  

  return `/api/v1/support/learners/${id}/unblock/`
}

export const supportLearnersUnblockCreate = async (id: string,
    supportTicketRefRequest: SupportTicketRefRequest, options?: RequestInit): Promise<supportLearnersUnblockCreateResponse> => {
  
  return apiFetch<supportLearnersUnblockCreateResponse>(getSupportLearnersUnblockCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportTicketRefRequest,)
  }
);}




export const getSupportLearnersUnblockCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersUnblockCreate>>, TError,{id: string;data: SupportTicketRefRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportLearnersUnblockCreate>>, TError,{id: string;data: SupportTicketRefRequest}, TContext> => {

const mutationKey = ['supportLearnersUnblockCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportLearnersUnblockCreate>>, {id: string;data: SupportTicketRefRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportLearnersUnblockCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportLearnersUnblockCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportLearnersUnblockCreate>>>
    export type SupportLearnersUnblockCreateMutationBody = SupportTicketRefRequest
    export type SupportLearnersUnblockCreateMutationError = unknown

    export const useSupportLearnersUnblockCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportLearnersUnblockCreate>>, TError,{id: string;data: SupportTicketRefRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportLearnersUnblockCreate>>,
        TError,
        {id: string;data: SupportTicketRefRequest},
        TContext
      > => {

      const mutationOptions = getSupportLearnersUnblockCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Saved replies (FR/EN, variables {name}, {number}, {agency}). Deleting = deactivating.
 */
export type supportMacrosListResponse200 = {
  data: PaginatedSupportMacroList
  status: 200
}
    
export type supportMacrosListResponseSuccess = (supportMacrosListResponse200) & {
  headers: Headers;
};
;

export type supportMacrosListResponse = (supportMacrosListResponseSuccess)

export const getSupportMacrosListUrl = (params?: SupportMacrosListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/macros/?${stringifiedParams}` : `/api/v1/support/macros/`
}

export const supportMacrosList = async (params?: SupportMacrosListParams, options?: RequestInit): Promise<supportMacrosListResponse> => {
  
  return apiFetch<supportMacrosListResponse>(getSupportMacrosListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportMacrosListQueryKey = (params?: SupportMacrosListParams,) => {
    return [
    `/api/v1/support/macros/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportMacrosListQueryOptions = <TData = Awaited<ReturnType<typeof supportMacrosList>>, TError = unknown>(params?: SupportMacrosListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportMacrosListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportMacrosList>>> = ({ signal }) => supportMacrosList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportMacrosList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportMacrosListQueryResult = NonNullable<Awaited<ReturnType<typeof supportMacrosList>>>
export type SupportMacrosListQueryError = unknown


export function useSupportMacrosList<TData = Awaited<ReturnType<typeof supportMacrosList>>, TError = unknown>(
 params: undefined |  SupportMacrosListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMacrosList>>,
          TError,
          Awaited<ReturnType<typeof supportMacrosList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMacrosList<TData = Awaited<ReturnType<typeof supportMacrosList>>, TError = unknown>(
 params?: SupportMacrosListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMacrosList>>,
          TError,
          Awaited<ReturnType<typeof supportMacrosList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMacrosList<TData = Awaited<ReturnType<typeof supportMacrosList>>, TError = unknown>(
 params?: SupportMacrosListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportMacrosList<TData = Awaited<ReturnType<typeof supportMacrosList>>, TError = unknown>(
 params?: SupportMacrosListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportMacrosListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Saved replies (FR/EN, variables {name}, {number}, {agency}). Deleting = deactivating.
 */
export type supportMacrosCreateResponse201 = {
  data: SupportMacro
  status: 201
}
    
export type supportMacrosCreateResponseSuccess = (supportMacrosCreateResponse201) & {
  headers: Headers;
};
;

export type supportMacrosCreateResponse = (supportMacrosCreateResponseSuccess)

export const getSupportMacrosCreateUrl = () => {


  

  return `/api/v1/support/macros/`
}

export const supportMacrosCreate = async (supportMacroRequest: SupportMacroRequest, options?: RequestInit): Promise<supportMacrosCreateResponse> => {
  
  return apiFetch<supportMacrosCreateResponse>(getSupportMacrosCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportMacroRequest,)
  }
);}




export const getSupportMacrosCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMacrosCreate>>, TError,{data: SupportMacroRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportMacrosCreate>>, TError,{data: SupportMacroRequest}, TContext> => {

const mutationKey = ['supportMacrosCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportMacrosCreate>>, {data: SupportMacroRequest}> = (props) => {
          const {data} = props ?? {};

          return  supportMacrosCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportMacrosCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportMacrosCreate>>>
    export type SupportMacrosCreateMutationBody = SupportMacroRequest
    export type SupportMacrosCreateMutationError = unknown

    export const useSupportMacrosCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMacrosCreate>>, TError,{data: SupportMacroRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportMacrosCreate>>,
        TError,
        {data: SupportMacroRequest},
        TContext
      > => {

      const mutationOptions = getSupportMacrosCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Saved replies (FR/EN, variables {name}, {number}, {agency}). Deleting = deactivating.
 */
export type supportMacrosRetrieveResponse200 = {
  data: SupportMacro
  status: 200
}
    
export type supportMacrosRetrieveResponseSuccess = (supportMacrosRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportMacrosRetrieveResponse = (supportMacrosRetrieveResponseSuccess)

export const getSupportMacrosRetrieveUrl = (id: string,) => {


  

  return `/api/v1/support/macros/${id}/`
}

export const supportMacrosRetrieve = async (id: string, options?: RequestInit): Promise<supportMacrosRetrieveResponse> => {
  
  return apiFetch<supportMacrosRetrieveResponse>(getSupportMacrosRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportMacrosRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/support/macros/${id}/`
    ] as const;
    }

    
export const getSupportMacrosRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportMacrosRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportMacrosRetrieve>>> = ({ signal }) => supportMacrosRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportMacrosRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportMacrosRetrieve>>>
export type SupportMacrosRetrieveQueryError = unknown


export function useSupportMacrosRetrieve<TData = Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMacrosRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportMacrosRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMacrosRetrieve<TData = Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMacrosRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportMacrosRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMacrosRetrieve<TData = Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportMacrosRetrieve<TData = Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMacrosRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportMacrosRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Saved replies (FR/EN, variables {name}, {number}, {agency}). Deleting = deactivating.
 */
export type supportMacrosPartialUpdateResponse200 = {
  data: SupportMacro
  status: 200
}
    
export type supportMacrosPartialUpdateResponseSuccess = (supportMacrosPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type supportMacrosPartialUpdateResponse = (supportMacrosPartialUpdateResponseSuccess)

export const getSupportMacrosPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/support/macros/${id}/`
}

export const supportMacrosPartialUpdate = async (id: string,
    patchedSupportMacroRequest: PatchedSupportMacroRequest, options?: RequestInit): Promise<supportMacrosPartialUpdateResponse> => {
  
  return apiFetch<supportMacrosPartialUpdateResponse>(getSupportMacrosPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedSupportMacroRequest,)
  }
);}




export const getSupportMacrosPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMacrosPartialUpdate>>, TError,{id: string;data: PatchedSupportMacroRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportMacrosPartialUpdate>>, TError,{id: string;data: PatchedSupportMacroRequest}, TContext> => {

const mutationKey = ['supportMacrosPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportMacrosPartialUpdate>>, {id: string;data: PatchedSupportMacroRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportMacrosPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportMacrosPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof supportMacrosPartialUpdate>>>
    export type SupportMacrosPartialUpdateMutationBody = PatchedSupportMacroRequest
    export type SupportMacrosPartialUpdateMutationError = unknown

    export const useSupportMacrosPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMacrosPartialUpdate>>, TError,{id: string;data: PatchedSupportMacroRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportMacrosPartialUpdate>>,
        TError,
        {id: string;data: PatchedSupportMacroRequest},
        TContext
      > => {

      const mutationOptions = getSupportMacrosPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportMeOptionsRetrieveResponse200 = {
  data: SupportMyOptions
  status: 200
}
    
export type supportMeOptionsRetrieveResponseSuccess = (supportMeOptionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportMeOptionsRetrieveResponse = (supportMeOptionsRetrieveResponseSuccess)

export const getSupportMeOptionsRetrieveUrl = () => {


  

  return `/api/v1/support/me/options/`
}

export const supportMeOptionsRetrieve = async ( options?: RequestInit): Promise<supportMeOptionsRetrieveResponse> => {
  
  return apiFetch<supportMeOptionsRetrieveResponse>(getSupportMeOptionsRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportMeOptionsRetrieveQueryKey = () => {
    return [
    `/api/v1/support/me/options/`
    ] as const;
    }

    
export const getSupportMeOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportMeOptionsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportMeOptionsRetrieve>>> = ({ signal }) => supportMeOptionsRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportMeOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportMeOptionsRetrieve>>>
export type SupportMeOptionsRetrieveQueryError = unknown


export function useSupportMeOptionsRetrieve<TData = Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMeOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportMeOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMeOptionsRetrieve<TData = Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMeOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportMeOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMeOptionsRetrieve<TData = Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportMeOptionsRetrieve<TData = Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportMeOptionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type supportMeTicketsListResponse200 = {
  data: SupportMyTicket[]
  status: 200
}
    
export type supportMeTicketsListResponseSuccess = (supportMeTicketsListResponse200) & {
  headers: Headers;
};
;

export type supportMeTicketsListResponse = (supportMeTicketsListResponseSuccess)

export const getSupportMeTicketsListUrl = () => {


  

  return `/api/v1/support/me/tickets/`
}

export const supportMeTicketsList = async ( options?: RequestInit): Promise<supportMeTicketsListResponse> => {
  
  return apiFetch<supportMeTicketsListResponse>(getSupportMeTicketsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportMeTicketsListQueryKey = () => {
    return [
    `/api/v1/support/me/tickets/`
    ] as const;
    }

    
export const getSupportMeTicketsListQueryOptions = <TData = Awaited<ReturnType<typeof supportMeTicketsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportMeTicketsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportMeTicketsList>>> = ({ signal }) => supportMeTicketsList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportMeTicketsListQueryResult = NonNullable<Awaited<ReturnType<typeof supportMeTicketsList>>>
export type SupportMeTicketsListQueryError = unknown


export function useSupportMeTicketsList<TData = Awaited<ReturnType<typeof supportMeTicketsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMeTicketsList>>,
          TError,
          Awaited<ReturnType<typeof supportMeTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMeTicketsList<TData = Awaited<ReturnType<typeof supportMeTicketsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMeTicketsList>>,
          TError,
          Awaited<ReturnType<typeof supportMeTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMeTicketsList<TData = Awaited<ReturnType<typeof supportMeTicketsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportMeTicketsList<TData = Awaited<ReturnType<typeof supportMeTicketsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportMeTicketsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type supportMeTicketsCreateResponse201 = {
  data: SupportMyTicketDetail
  status: 201
}
    
export type supportMeTicketsCreateResponseSuccess = (supportMeTicketsCreateResponse201) & {
  headers: Headers;
};
;

export type supportMeTicketsCreateResponse = (supportMeTicketsCreateResponseSuccess)

export const getSupportMeTicketsCreateUrl = () => {


  

  return `/api/v1/support/me/tickets/`
}

export const supportMeTicketsCreate = async (supportMyTicketCreateRequest: SupportMyTicketCreateRequest, options?: RequestInit): Promise<supportMeTicketsCreateResponse> => {
    const formData = new FormData();
formData.append(`subject`, supportMyTicketCreateRequest.subject)
formData.append(`body`, supportMyTicketCreateRequest.body)
formData.append(`category`, supportMyTicketCreateRequest.category)
if(supportMyTicketCreateRequest.complaint !== undefined) {
 formData.append(`complaint`, supportMyTicketCreateRequest.complaint.toString())
 }
if(supportMyTicketCreateRequest.invoice_number !== undefined) {
 formData.append(`invoice_number`, supportMyTicketCreateRequest.invoice_number)
 }
if(supportMyTicketCreateRequest.files !== undefined) {
 supportMyTicketCreateRequest.files.forEach(value => formData.append(`files`, value));
 }

  return apiFetch<supportMeTicketsCreateResponse>(getSupportMeTicketsCreateUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getSupportMeTicketsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMeTicketsCreate>>, TError,{data: SupportMyTicketCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportMeTicketsCreate>>, TError,{data: SupportMyTicketCreateRequest}, TContext> => {

const mutationKey = ['supportMeTicketsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportMeTicketsCreate>>, {data: SupportMyTicketCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  supportMeTicketsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportMeTicketsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportMeTicketsCreate>>>
    export type SupportMeTicketsCreateMutationBody = SupportMyTicketCreateRequest
    export type SupportMeTicketsCreateMutationError = unknown

    export const useSupportMeTicketsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMeTicketsCreate>>, TError,{data: SupportMyTicketCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportMeTicketsCreate>>,
        TError,
        {data: SupportMyTicketCreateRequest},
        TContext
      > => {

      const mutationOptions = getSupportMeTicketsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportMeTicketsRetrieveResponse200 = {
  data: SupportMyTicketDetail
  status: 200
}
    
export type supportMeTicketsRetrieveResponseSuccess = (supportMeTicketsRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportMeTicketsRetrieveResponse = (supportMeTicketsRetrieveResponseSuccess)

export const getSupportMeTicketsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/support/me/tickets/${id}/`
}

export const supportMeTicketsRetrieve = async (id: string, options?: RequestInit): Promise<supportMeTicketsRetrieveResponse> => {
  
  return apiFetch<supportMeTicketsRetrieveResponse>(getSupportMeTicketsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportMeTicketsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/support/me/tickets/${id}/`
    ] as const;
    }

    
export const getSupportMeTicketsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportMeTicketsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportMeTicketsRetrieve>>> = ({ signal }) => supportMeTicketsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportMeTicketsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportMeTicketsRetrieve>>>
export type SupportMeTicketsRetrieveQueryError = unknown


export function useSupportMeTicketsRetrieve<TData = Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMeTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportMeTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMeTicketsRetrieve<TData = Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportMeTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportMeTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportMeTicketsRetrieve<TData = Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportMeTicketsRetrieve<TData = Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportMeTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportMeTicketsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type supportMeTicketsCsatCreateResponse200 = {
  data: SupportMyTicket
  status: 200
}
    
export type supportMeTicketsCsatCreateResponseSuccess = (supportMeTicketsCsatCreateResponse200) & {
  headers: Headers;
};
;

export type supportMeTicketsCsatCreateResponse = (supportMeTicketsCsatCreateResponseSuccess)

export const getSupportMeTicketsCsatCreateUrl = (id: string,) => {


  

  return `/api/v1/support/me/tickets/${id}/csat/`
}

export const supportMeTicketsCsatCreate = async (id: string,
    supportCsatRequest: SupportCsatRequest, options?: RequestInit): Promise<supportMeTicketsCsatCreateResponse> => {
  
  return apiFetch<supportMeTicketsCsatCreateResponse>(getSupportMeTicketsCsatCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportCsatRequest,)
  }
);}




export const getSupportMeTicketsCsatCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMeTicketsCsatCreate>>, TError,{id: string;data: SupportCsatRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportMeTicketsCsatCreate>>, TError,{id: string;data: SupportCsatRequest}, TContext> => {

const mutationKey = ['supportMeTicketsCsatCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportMeTicketsCsatCreate>>, {id: string;data: SupportCsatRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportMeTicketsCsatCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportMeTicketsCsatCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportMeTicketsCsatCreate>>>
    export type SupportMeTicketsCsatCreateMutationBody = SupportCsatRequest
    export type SupportMeTicketsCsatCreateMutationError = unknown

    export const useSupportMeTicketsCsatCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMeTicketsCsatCreate>>, TError,{id: string;data: SupportCsatRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportMeTicketsCsatCreate>>,
        TError,
        {id: string;data: SupportCsatRequest},
        TContext
      > => {

      const mutationOptions = getSupportMeTicketsCsatCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportMeTicketsReplyCreateResponse200 = {
  data: SupportMyTicketDetail
  status: 200
}
    
export type supportMeTicketsReplyCreateResponseSuccess = (supportMeTicketsReplyCreateResponse200) & {
  headers: Headers;
};
;

export type supportMeTicketsReplyCreateResponse = (supportMeTicketsReplyCreateResponseSuccess)

export const getSupportMeTicketsReplyCreateUrl = (id: string,) => {


  

  return `/api/v1/support/me/tickets/${id}/reply/`
}

export const supportMeTicketsReplyCreate = async (id: string,
    supportMyReplyRequest: SupportMyReplyRequest, options?: RequestInit): Promise<supportMeTicketsReplyCreateResponse> => {
    const formData = new FormData();
formData.append(`body`, supportMyReplyRequest.body)
if(supportMyReplyRequest.files !== undefined) {
 supportMyReplyRequest.files.forEach(value => formData.append(`files`, value));
 }

  return apiFetch<supportMeTicketsReplyCreateResponse>(getSupportMeTicketsReplyCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getSupportMeTicketsReplyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMeTicketsReplyCreate>>, TError,{id: string;data: SupportMyReplyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportMeTicketsReplyCreate>>, TError,{id: string;data: SupportMyReplyRequest}, TContext> => {

const mutationKey = ['supportMeTicketsReplyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportMeTicketsReplyCreate>>, {id: string;data: SupportMyReplyRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportMeTicketsReplyCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportMeTicketsReplyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportMeTicketsReplyCreate>>>
    export type SupportMeTicketsReplyCreateMutationBody = SupportMyReplyRequest
    export type SupportMeTicketsReplyCreateMutationError = unknown

    export const useSupportMeTicketsReplyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMeTicketsReplyCreate>>, TError,{id: string;data: SupportMyReplyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportMeTicketsReplyCreate>>,
        TError,
        {id: string;data: SupportMyReplyRequest},
        TContext
      > => {

      const mutationOptions = getSupportMeTicketsReplyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The survey link of the « resolved » e-mail: no account needed, the token is the key.
 */
export type supportPublicCsatRetrieveResponse200 = {
  data: SupportPublicCsat
  status: 200
}
    
export type supportPublicCsatRetrieveResponseSuccess = (supportPublicCsatRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportPublicCsatRetrieveResponse = (supportPublicCsatRetrieveResponseSuccess)

export const getSupportPublicCsatRetrieveUrl = (token: string,) => {


  

  return `/api/v1/support/public/csat/${token}/`
}

export const supportPublicCsatRetrieve = async (token: string, options?: RequestInit): Promise<supportPublicCsatRetrieveResponse> => {
  
  return apiFetch<supportPublicCsatRetrieveResponse>(getSupportPublicCsatRetrieveUrl(token),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportPublicCsatRetrieveQueryKey = (token?: string,) => {
    return [
    `/api/v1/support/public/csat/${token}/`
    ] as const;
    }

    
export const getSupportPublicCsatRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportPublicCsatRetrieveQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportPublicCsatRetrieve>>> = ({ signal }) => supportPublicCsatRetrieve(token, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportPublicCsatRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportPublicCsatRetrieve>>>
export type SupportPublicCsatRetrieveQueryError = unknown


export function useSupportPublicCsatRetrieve<TData = Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportPublicCsatRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportPublicCsatRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportPublicCsatRetrieve<TData = Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportPublicCsatRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportPublicCsatRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportPublicCsatRetrieve<TData = Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportPublicCsatRetrieve<TData = Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportPublicCsatRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportPublicCsatRetrieveQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The survey link of the « resolved » e-mail: no account needed, the token is the key.
 */
export type supportPublicCsatCreateResponse200 = {
  data: SupportPublicCsat
  status: 200
}
    
export type supportPublicCsatCreateResponseSuccess = (supportPublicCsatCreateResponse200) & {
  headers: Headers;
};
;

export type supportPublicCsatCreateResponse = (supportPublicCsatCreateResponseSuccess)

export const getSupportPublicCsatCreateUrl = (token: string,) => {


  

  return `/api/v1/support/public/csat/${token}/`
}

export const supportPublicCsatCreate = async (token: string,
    supportCsatRequest: SupportCsatRequest, options?: RequestInit): Promise<supportPublicCsatCreateResponse> => {
  
  return apiFetch<supportPublicCsatCreateResponse>(getSupportPublicCsatCreateUrl(token),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportCsatRequest,)
  }
);}




export const getSupportPublicCsatCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportPublicCsatCreate>>, TError,{token: string;data: SupportCsatRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportPublicCsatCreate>>, TError,{token: string;data: SupportCsatRequest}, TContext> => {

const mutationKey = ['supportPublicCsatCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportPublicCsatCreate>>, {token: string;data: SupportCsatRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  supportPublicCsatCreate(token,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportPublicCsatCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportPublicCsatCreate>>>
    export type SupportPublicCsatCreateMutationBody = SupportCsatRequest
    export type SupportPublicCsatCreateMutationError = unknown

    export const useSupportPublicCsatCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportPublicCsatCreate>>, TError,{token: string;data: SupportCsatRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportPublicCsatCreate>>,
        TError,
        {token: string;data: SupportCsatRequest},
        TContext
      > => {

      const mutationOptions = getSupportPublicCsatCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportRefundsListResponse200 = {
  data: PaginatedSupportRefundList
  status: 200
}
    
export type supportRefundsListResponseSuccess = (supportRefundsListResponse200) & {
  headers: Headers;
};
;

export type supportRefundsListResponse = (supportRefundsListResponseSuccess)

export const getSupportRefundsListUrl = (params?: SupportRefundsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/refunds/?${stringifiedParams}` : `/api/v1/support/refunds/`
}

export const supportRefundsList = async (params?: SupportRefundsListParams, options?: RequestInit): Promise<supportRefundsListResponse> => {
  
  return apiFetch<supportRefundsListResponse>(getSupportRefundsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportRefundsListQueryKey = (params?: SupportRefundsListParams,) => {
    return [
    `/api/v1/support/refunds/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportRefundsListQueryOptions = <TData = Awaited<ReturnType<typeof supportRefundsList>>, TError = unknown>(params?: SupportRefundsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportRefundsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportRefundsList>>> = ({ signal }) => supportRefundsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportRefundsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportRefundsListQueryResult = NonNullable<Awaited<ReturnType<typeof supportRefundsList>>>
export type SupportRefundsListQueryError = unknown


export function useSupportRefundsList<TData = Awaited<ReturnType<typeof supportRefundsList>>, TError = unknown>(
 params: undefined |  SupportRefundsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportRefundsList>>,
          TError,
          Awaited<ReturnType<typeof supportRefundsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportRefundsList<TData = Awaited<ReturnType<typeof supportRefundsList>>, TError = unknown>(
 params?: SupportRefundsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportRefundsList>>,
          TError,
          Awaited<ReturnType<typeof supportRefundsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportRefundsList<TData = Awaited<ReturnType<typeof supportRefundsList>>, TError = unknown>(
 params?: SupportRefundsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportRefundsList<TData = Awaited<ReturnType<typeof supportRefundsList>>, TError = unknown>(
 params?: SupportRefundsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportRefundsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type supportRefundsCreateResponse201 = {
  data: SupportRefund
  status: 201
}
    
export type supportRefundsCreateResponseSuccess = (supportRefundsCreateResponse201) & {
  headers: Headers;
};
;

export type supportRefundsCreateResponse = (supportRefundsCreateResponseSuccess)

export const getSupportRefundsCreateUrl = () => {


  

  return `/api/v1/support/refunds/`
}

export const supportRefundsCreate = async (supportRefundCreateRequest: SupportRefundCreateRequest, options?: RequestInit): Promise<supportRefundsCreateResponse> => {
  
  return apiFetch<supportRefundsCreateResponse>(getSupportRefundsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportRefundCreateRequest,)
  }
);}




export const getSupportRefundsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportRefundsCreate>>, TError,{data: SupportRefundCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportRefundsCreate>>, TError,{data: SupportRefundCreateRequest}, TContext> => {

const mutationKey = ['supportRefundsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportRefundsCreate>>, {data: SupportRefundCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  supportRefundsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportRefundsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportRefundsCreate>>>
    export type SupportRefundsCreateMutationBody = SupportRefundCreateRequest
    export type SupportRefundsCreateMutationError = unknown

    export const useSupportRefundsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportRefundsCreate>>, TError,{data: SupportRefundCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportRefundsCreate>>,
        TError,
        {data: SupportRefundCreateRequest},
        TContext
      > => {

      const mutationOptions = getSupportRefundsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportRefundsRetrieveResponse200 = {
  data: SupportRefund
  status: 200
}
    
export type supportRefundsRetrieveResponseSuccess = (supportRefundsRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportRefundsRetrieveResponse = (supportRefundsRetrieveResponseSuccess)

export const getSupportRefundsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/support/refunds/${id}/`
}

export const supportRefundsRetrieve = async (id: string, options?: RequestInit): Promise<supportRefundsRetrieveResponse> => {
  
  return apiFetch<supportRefundsRetrieveResponse>(getSupportRefundsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportRefundsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/support/refunds/${id}/`
    ] as const;
    }

    
export const getSupportRefundsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportRefundsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportRefundsRetrieve>>> = ({ signal }) => supportRefundsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportRefundsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportRefundsRetrieve>>>
export type SupportRefundsRetrieveQueryError = unknown


export function useSupportRefundsRetrieve<TData = Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportRefundsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportRefundsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportRefundsRetrieve<TData = Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportRefundsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportRefundsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportRefundsRetrieve<TData = Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportRefundsRetrieve<TData = Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportRefundsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportRefundsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type supportRefundsDecideCreateResponse200 = {
  data: SupportRefund
  status: 200
}
    
export type supportRefundsDecideCreateResponseSuccess = (supportRefundsDecideCreateResponse200) & {
  headers: Headers;
};
;

export type supportRefundsDecideCreateResponse = (supportRefundsDecideCreateResponseSuccess)

export const getSupportRefundsDecideCreateUrl = (id: string,) => {


  

  return `/api/v1/support/refunds/${id}/decide/`
}

export const supportRefundsDecideCreate = async (id: string,
    supportDecideRequest: SupportDecideRequest, options?: RequestInit): Promise<supportRefundsDecideCreateResponse> => {
  
  return apiFetch<supportRefundsDecideCreateResponse>(getSupportRefundsDecideCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportDecideRequest,)
  }
);}




export const getSupportRefundsDecideCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportRefundsDecideCreate>>, TError,{id: string;data: SupportDecideRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportRefundsDecideCreate>>, TError,{id: string;data: SupportDecideRequest}, TContext> => {

const mutationKey = ['supportRefundsDecideCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportRefundsDecideCreate>>, {id: string;data: SupportDecideRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportRefundsDecideCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportRefundsDecideCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportRefundsDecideCreate>>>
    export type SupportRefundsDecideCreateMutationBody = SupportDecideRequest
    export type SupportRefundsDecideCreateMutationError = unknown

    export const useSupportRefundsDecideCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportRefundsDecideCreate>>, TError,{id: string;data: SupportDecideRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportRefundsDecideCreate>>,
        TError,
        {id: string;data: SupportDecideRequest},
        TContext
      > => {

      const mutationOptions = getSupportRefundsDecideCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportTicketsListResponse200 = {
  data: PaginatedSupportTicketList
  status: 200
}
    
export type supportTicketsListResponseSuccess = (supportTicketsListResponse200) & {
  headers: Headers;
};
;

export type supportTicketsListResponse = (supportTicketsListResponseSuccess)

export const getSupportTicketsListUrl = (params?: SupportTicketsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/tickets/?${stringifiedParams}` : `/api/v1/support/tickets/`
}

export const supportTicketsList = async (params?: SupportTicketsListParams, options?: RequestInit): Promise<supportTicketsListResponse> => {
  
  return apiFetch<supportTicketsListResponse>(getSupportTicketsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportTicketsListQueryKey = (params?: SupportTicketsListParams,) => {
    return [
    `/api/v1/support/tickets/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportTicketsListQueryOptions = <TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(params?: SupportTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportTicketsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportTicketsList>>> = ({ signal }) => supportTicketsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportTicketsListQueryResult = NonNullable<Awaited<ReturnType<typeof supportTicketsList>>>
export type SupportTicketsListQueryError = unknown


export function useSupportTicketsList<TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(
 params: undefined |  SupportTicketsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsList>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportTicketsList<TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(
 params?: SupportTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsList>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportTicketsList<TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(
 params?: SupportTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportTicketsList<TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(
 params?: SupportTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportTicketsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type supportTicketsCreateResponse201 = {
  data: SupportTicketDetail
  status: 201
}
    
export type supportTicketsCreateResponseSuccess = (supportTicketsCreateResponse201) & {
  headers: Headers;
};
;

export type supportTicketsCreateResponse = (supportTicketsCreateResponseSuccess)

export const getSupportTicketsCreateUrl = () => {


  

  return `/api/v1/support/tickets/`
}

export const supportTicketsCreate = async (supportTicketCreateRequest: SupportTicketCreateRequest, options?: RequestInit): Promise<supportTicketsCreateResponse> => {
    const formData = new FormData();
formData.append(`subject`, supportTicketCreateRequest.subject)
formData.append(`body`, supportTicketCreateRequest.body)
if(supportTicketCreateRequest.channel !== undefined) {
 formData.append(`channel`, supportTicketCreateRequest.channel)
 }
formData.append(`category`, supportTicketCreateRequest.category)
if(supportTicketCreateRequest.priority !== undefined) {
 formData.append(`priority`, supportTicketCreateRequest.priority)
 }
if(supportTicketCreateRequest.language !== undefined) {
 formData.append(`language`, supportTicketCreateRequest.language)
 }
if(supportTicketCreateRequest.requester_name !== undefined) {
 formData.append(`requester_name`, supportTicketCreateRequest.requester_name)
 }
if(supportTicketCreateRequest.requester_email !== undefined) {
 formData.append(`requester_email`, supportTicketCreateRequest.requester_email)
 }
if(supportTicketCreateRequest.requester_phone !== undefined) {
 formData.append(`requester_phone`, supportTicketCreateRequest.requester_phone)
 }
if(supportTicketCreateRequest.contact !== undefined && supportTicketCreateRequest.contact !== null) {
 formData.append(`contact`, supportTicketCreateRequest.contact)
 }
if(supportTicketCreateRequest.learner !== undefined && supportTicketCreateRequest.learner !== null) {
 formData.append(`learner`, supportTicketCreateRequest.learner)
 }
if(supportTicketCreateRequest.invoice !== undefined && supportTicketCreateRequest.invoice !== null) {
 formData.append(`invoice`, supportTicketCreateRequest.invoice)
 }
if(supportTicketCreateRequest.dossier !== undefined && supportTicketCreateRequest.dossier !== null) {
 formData.append(`dossier`, supportTicketCreateRequest.dossier)
 }
if(supportTicketCreateRequest.tags !== undefined) {
 supportTicketCreateRequest.tags.forEach(value => formData.append(`tags`, value));
 }

  return apiFetch<supportTicketsCreateResponse>(getSupportTicketsCreateUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getSupportTicketsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsCreate>>, TError,{data: SupportTicketCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsCreate>>, TError,{data: SupportTicketCreateRequest}, TContext> => {

const mutationKey = ['supportTicketsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsCreate>>, {data: SupportTicketCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  supportTicketsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsCreate>>>
    export type SupportTicketsCreateMutationBody = SupportTicketCreateRequest
    export type SupportTicketsCreateMutationError = unknown

    export const useSupportTicketsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsCreate>>, TError,{data: SupportTicketCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsCreate>>,
        TError,
        {data: SupportTicketCreateRequest},
        TContext
      > => {

      const mutationOptions = getSupportTicketsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportTicketsRetrieveResponse200 = {
  data: SupportTicketDetail
  status: 200
}
    
export type supportTicketsRetrieveResponseSuccess = (supportTicketsRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportTicketsRetrieveResponse = (supportTicketsRetrieveResponseSuccess)

export const getSupportTicketsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/support/tickets/${id}/`
}

export const supportTicketsRetrieve = async (id: string, options?: RequestInit): Promise<supportTicketsRetrieveResponse> => {
  
  return apiFetch<supportTicketsRetrieveResponse>(getSupportTicketsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportTicketsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/support/tickets/${id}/`
    ] as const;
    }

    
export const getSupportTicketsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportTicketsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportTicketsRetrieve>>> = ({ signal }) => supportTicketsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportTicketsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportTicketsRetrieve>>>
export type SupportTicketsRetrieveQueryError = unknown


export function useSupportTicketsRetrieve<TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportTicketsRetrieve<TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportTicketsRetrieve<TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportTicketsRetrieve<TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportTicketsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type supportTicketsAssignCreateResponse200 = {
  data: SupportTicketDetail
  status: 200
}
    
export type supportTicketsAssignCreateResponseSuccess = (supportTicketsAssignCreateResponse200) & {
  headers: Headers;
};
;

export type supportTicketsAssignCreateResponse = (supportTicketsAssignCreateResponseSuccess)

export const getSupportTicketsAssignCreateUrl = (id: string,) => {


  

  return `/api/v1/support/tickets/${id}/assign/`
}

export const supportTicketsAssignCreate = async (id: string,
    supportAssignRequest: SupportAssignRequest, options?: RequestInit): Promise<supportTicketsAssignCreateResponse> => {
  
  return apiFetch<supportTicketsAssignCreateResponse>(getSupportTicketsAssignCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportAssignRequest,)
  }
);}




export const getSupportTicketsAssignCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsAssignCreate>>, TError,{id: string;data: SupportAssignRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsAssignCreate>>, TError,{id: string;data: SupportAssignRequest}, TContext> => {

const mutationKey = ['supportTicketsAssignCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsAssignCreate>>, {id: string;data: SupportAssignRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsAssignCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsAssignCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsAssignCreate>>>
    export type SupportTicketsAssignCreateMutationBody = SupportAssignRequest
    export type SupportTicketsAssignCreateMutationError = unknown

    export const useSupportTicketsAssignCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsAssignCreate>>, TError,{id: string;data: SupportAssignRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsAssignCreate>>,
        TError,
        {id: string;data: SupportAssignRequest},
        TContext
      > => {

      const mutationOptions = getSupportTicketsAssignCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * This ticket (a duplicate) is merged INTO `target`.
 */
export type supportTicketsMergeCreateResponse200 = {
  data: SupportTicketDetail
  status: 200
}
    
export type supportTicketsMergeCreateResponseSuccess = (supportTicketsMergeCreateResponse200) & {
  headers: Headers;
};
;

export type supportTicketsMergeCreateResponse = (supportTicketsMergeCreateResponseSuccess)

export const getSupportTicketsMergeCreateUrl = (id: string,) => {


  

  return `/api/v1/support/tickets/${id}/merge/`
}

export const supportTicketsMergeCreate = async (id: string,
    supportMergeRequest: SupportMergeRequest, options?: RequestInit): Promise<supportTicketsMergeCreateResponse> => {
  
  return apiFetch<supportTicketsMergeCreateResponse>(getSupportTicketsMergeCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportMergeRequest,)
  }
);}




export const getSupportTicketsMergeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsMergeCreate>>, TError,{id: string;data: SupportMergeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsMergeCreate>>, TError,{id: string;data: SupportMergeRequest}, TContext> => {

const mutationKey = ['supportTicketsMergeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsMergeCreate>>, {id: string;data: SupportMergeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsMergeCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsMergeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsMergeCreate>>>
    export type SupportTicketsMergeCreateMutationBody = SupportMergeRequest
    export type SupportTicketsMergeCreateMutationError = unknown

    export const useSupportTicketsMergeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsMergeCreate>>, TError,{id: string;data: SupportMergeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsMergeCreate>>,
        TError,
        {id: string;data: SupportMergeRequest},
        TContext
      > => {

      const mutationOptions = getSupportTicketsMergeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportTicketsPriorityCreateResponse200 = {
  data: SupportTicketDetail
  status: 200
}
    
export type supportTicketsPriorityCreateResponseSuccess = (supportTicketsPriorityCreateResponse200) & {
  headers: Headers;
};
;

export type supportTicketsPriorityCreateResponse = (supportTicketsPriorityCreateResponseSuccess)

export const getSupportTicketsPriorityCreateUrl = (id: string,) => {


  

  return `/api/v1/support/tickets/${id}/priority/`
}

export const supportTicketsPriorityCreate = async (id: string,
    supportPriorityRequest: SupportPriorityRequest, options?: RequestInit): Promise<supportTicketsPriorityCreateResponse> => {
  
  return apiFetch<supportTicketsPriorityCreateResponse>(getSupportTicketsPriorityCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportPriorityRequest,)
  }
);}




export const getSupportTicketsPriorityCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsPriorityCreate>>, TError,{id: string;data: SupportPriorityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsPriorityCreate>>, TError,{id: string;data: SupportPriorityRequest}, TContext> => {

const mutationKey = ['supportTicketsPriorityCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsPriorityCreate>>, {id: string;data: SupportPriorityRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsPriorityCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsPriorityCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsPriorityCreate>>>
    export type SupportTicketsPriorityCreateMutationBody = SupportPriorityRequest
    export type SupportTicketsPriorityCreateMutationError = unknown

    export const useSupportTicketsPriorityCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsPriorityCreate>>, TError,{id: string;data: SupportPriorityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsPriorityCreate>>,
        TError,
        {id: string;data: SupportPriorityRequest},
        TContext
      > => {

      const mutationOptions = getSupportTicketsPriorityCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportTicketsReplyCreateResponse200 = {
  data: SupportTicketDetail
  status: 200
}
    
export type supportTicketsReplyCreateResponseSuccess = (supportTicketsReplyCreateResponse200) & {
  headers: Headers;
};
;

export type supportTicketsReplyCreateResponse = (supportTicketsReplyCreateResponseSuccess)

export const getSupportTicketsReplyCreateUrl = (id: string,) => {


  

  return `/api/v1/support/tickets/${id}/reply/`
}

export const supportTicketsReplyCreate = async (id: string,
    supportReplyRequest: SupportReplyRequest, options?: RequestInit): Promise<supportTicketsReplyCreateResponse> => {
    const formData = new FormData();
formData.append(`body`, supportReplyRequest.body)
if(supportReplyRequest.internal !== undefined) {
 formData.append(`internal`, supportReplyRequest.internal.toString())
 }
if(supportReplyRequest.status !== undefined) {
 formData.append(`status`, supportReplyRequest.status)
 }
if(supportReplyRequest.from_ai_draft !== undefined) {
 formData.append(`from_ai_draft`, supportReplyRequest.from_ai_draft.toString())
 }
if(supportReplyRequest.files !== undefined) {
 supportReplyRequest.files.forEach(value => formData.append(`files`, value));
 }

  return apiFetch<supportTicketsReplyCreateResponse>(getSupportTicketsReplyCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getSupportTicketsReplyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsReplyCreate>>, TError,{id: string;data: SupportReplyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsReplyCreate>>, TError,{id: string;data: SupportReplyRequest}, TContext> => {

const mutationKey = ['supportTicketsReplyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsReplyCreate>>, {id: string;data: SupportReplyRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsReplyCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsReplyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsReplyCreate>>>
    export type SupportTicketsReplyCreateMutationBody = SupportReplyRequest
    export type SupportTicketsReplyCreateMutationError = unknown

    export const useSupportTicketsReplyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsReplyCreate>>, TError,{id: string;data: SupportReplyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsReplyCreate>>,
        TError,
        {id: string;data: SupportReplyRequest},
        TContext
      > => {

      const mutationOptions = getSupportTicketsReplyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportTicketsStatusCreateResponse200 = {
  data: SupportTicketDetail
  status: 200
}
    
export type supportTicketsStatusCreateResponseSuccess = (supportTicketsStatusCreateResponse200) & {
  headers: Headers;
};
;

export type supportTicketsStatusCreateResponse = (supportTicketsStatusCreateResponseSuccess)

export const getSupportTicketsStatusCreateUrl = (id: string,) => {


  

  return `/api/v1/support/tickets/${id}/status/`
}

export const supportTicketsStatusCreate = async (id: string,
    supportStatusRequest: SupportStatusRequest, options?: RequestInit): Promise<supportTicketsStatusCreateResponse> => {
  
  return apiFetch<supportTicketsStatusCreateResponse>(getSupportTicketsStatusCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportStatusRequest,)
  }
);}




export const getSupportTicketsStatusCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsStatusCreate>>, TError,{id: string;data: SupportStatusRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsStatusCreate>>, TError,{id: string;data: SupportStatusRequest}, TContext> => {

const mutationKey = ['supportTicketsStatusCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsStatusCreate>>, {id: string;data: SupportStatusRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsStatusCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsStatusCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsStatusCreate>>>
    export type SupportTicketsStatusCreateMutationBody = SupportStatusRequest
    export type SupportTicketsStatusCreateMutationError = unknown

    export const useSupportTicketsStatusCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsStatusCreate>>, TError,{id: string;data: SupportStatusRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsStatusCreate>>,
        TError,
        {id: string;data: SupportStatusRequest},
        TContext
      > => {

      const mutationOptions = getSupportTicketsStatusCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Asks the AI for a draft (Celery); the screen reads `ai_draft` again. Never sent.
 */
export type supportTicketsSuggestCreateResponse202 = {
  data: SupportTicketDetail
  status: 202
}
    
export type supportTicketsSuggestCreateResponseSuccess = (supportTicketsSuggestCreateResponse202) & {
  headers: Headers;
};
;

export type supportTicketsSuggestCreateResponse = (supportTicketsSuggestCreateResponseSuccess)

export const getSupportTicketsSuggestCreateUrl = (id: string,) => {


  

  return `/api/v1/support/tickets/${id}/suggest/`
}

export const supportTicketsSuggestCreate = async (id: string, options?: RequestInit): Promise<supportTicketsSuggestCreateResponse> => {
  
  return apiFetch<supportTicketsSuggestCreateResponse>(getSupportTicketsSuggestCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getSupportTicketsSuggestCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsSuggestCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsSuggestCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['supportTicketsSuggestCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsSuggestCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  supportTicketsSuggestCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsSuggestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsSuggestCreate>>>
    
    export type SupportTicketsSuggestCreateMutationError = unknown

    export const useSupportTicketsSuggestCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsSuggestCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsSuggestCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSupportTicketsSuggestCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportTicketsTagsCreateResponse200 = {
  data: SupportTicketDetail
  status: 200
}
    
export type supportTicketsTagsCreateResponseSuccess = (supportTicketsTagsCreateResponse200) & {
  headers: Headers;
};
;

export type supportTicketsTagsCreateResponse = (supportTicketsTagsCreateResponseSuccess)

export const getSupportTicketsTagsCreateUrl = (id: string,) => {


  

  return `/api/v1/support/tickets/${id}/tags/`
}

export const supportTicketsTagsCreate = async (id: string,
    supportTagsRequest: SupportTagsRequest, options?: RequestInit): Promise<supportTicketsTagsCreateResponse> => {
  
  return apiFetch<supportTicketsTagsCreateResponse>(getSupportTicketsTagsCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportTagsRequest,)
  }
);}




export const getSupportTicketsTagsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsTagsCreate>>, TError,{id: string;data: SupportTagsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsTagsCreate>>, TError,{id: string;data: SupportTagsRequest}, TContext> => {

const mutationKey = ['supportTicketsTagsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsTagsCreate>>, {id: string;data: SupportTagsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsTagsCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsTagsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsTagsCreate>>>
    export type SupportTicketsTagsCreateMutationBody = SupportTagsRequest
    export type SupportTicketsTagsCreateMutationError = unknown

    export const useSupportTicketsTagsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsTagsCreate>>, TError,{id: string;data: SupportTagsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsTagsCreate>>,
        TError,
        {id: string;data: SupportTagsRequest},
        TContext
      > => {

      const mutationOptions = getSupportTicketsTagsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportTicketsDashboardRetrieveResponse200 = {
  data: SupportDashboard
  status: 200
}
    
export type supportTicketsDashboardRetrieveResponseSuccess = (supportTicketsDashboardRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportTicketsDashboardRetrieveResponse = (supportTicketsDashboardRetrieveResponseSuccess)

export const getSupportTicketsDashboardRetrieveUrl = (params?: SupportTicketsDashboardRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/tickets/dashboard/?${stringifiedParams}` : `/api/v1/support/tickets/dashboard/`
}

export const supportTicketsDashboardRetrieve = async (params?: SupportTicketsDashboardRetrieveParams, options?: RequestInit): Promise<supportTicketsDashboardRetrieveResponse> => {
  
  return apiFetch<supportTicketsDashboardRetrieveResponse>(getSupportTicketsDashboardRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportTicketsDashboardRetrieveQueryKey = (params?: SupportTicketsDashboardRetrieveParams,) => {
    return [
    `/api/v1/support/tickets/dashboard/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportTicketsDashboardRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError = unknown>(params?: SupportTicketsDashboardRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportTicketsDashboardRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>> = ({ signal }) => supportTicketsDashboardRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportTicketsDashboardRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>>
export type SupportTicketsDashboardRetrieveQueryError = unknown


export function useSupportTicketsDashboardRetrieve<TData = Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError = unknown>(
 params: undefined |  SupportTicketsDashboardRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportTicketsDashboardRetrieve<TData = Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError = unknown>(
 params?: SupportTicketsDashboardRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportTicketsDashboardRetrieve<TData = Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError = unknown>(
 params?: SupportTicketsDashboardRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportTicketsDashboardRetrieve<TData = Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError = unknown>(
 params?: SupportTicketsDashboardRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsDashboardRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportTicketsDashboardRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Créer un ticket » from a conversation of the inbox (WhatsApp, Messenger).
 */
export type supportTicketsFromConversationCreateResponse201 = {
  data: SupportTicketDetail
  status: 201
}
    
export type supportTicketsFromConversationCreateResponseSuccess = (supportTicketsFromConversationCreateResponse201) & {
  headers: Headers;
};
;

export type supportTicketsFromConversationCreateResponse = (supportTicketsFromConversationCreateResponseSuccess)

export const getSupportTicketsFromConversationCreateUrl = () => {


  

  return `/api/v1/support/tickets/from-conversation/`
}

export const supportTicketsFromConversationCreate = async (supportFromConversationRequest: SupportFromConversationRequest, options?: RequestInit): Promise<supportTicketsFromConversationCreateResponse> => {
  
  return apiFetch<supportTicketsFromConversationCreateResponse>(getSupportTicketsFromConversationCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supportFromConversationRequest,)
  }
);}




export const getSupportTicketsFromConversationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsFromConversationCreate>>, TError,{data: SupportFromConversationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsFromConversationCreate>>, TError,{data: SupportFromConversationRequest}, TContext> => {

const mutationKey = ['supportTicketsFromConversationCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsFromConversationCreate>>, {data: SupportFromConversationRequest}> = (props) => {
          const {data} = props ?? {};

          return  supportTicketsFromConversationCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsFromConversationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsFromConversationCreate>>>
    export type SupportTicketsFromConversationCreateMutationBody = SupportFromConversationRequest
    export type SupportTicketsFromConversationCreateMutationError = unknown

    export const useSupportTicketsFromConversationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsFromConversationCreate>>, TError,{data: SupportFromConversationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsFromConversationCreate>>,
        TError,
        {data: SupportFromConversationRequest},
        TContext
      > => {

      const mutationOptions = getSupportTicketsFromConversationCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type supportTicketsSummaryRetrieveResponse200 = {
  data: SupportSummary
  status: 200
}
    
export type supportTicketsSummaryRetrieveResponseSuccess = (supportTicketsSummaryRetrieveResponse200) & {
  headers: Headers;
};
;

export type supportTicketsSummaryRetrieveResponse = (supportTicketsSummaryRetrieveResponseSuccess)

export const getSupportTicketsSummaryRetrieveUrl = () => {


  

  return `/api/v1/support/tickets/summary/`
}

export const supportTicketsSummaryRetrieve = async ( options?: RequestInit): Promise<supportTicketsSummaryRetrieveResponse> => {
  
  return apiFetch<supportTicketsSummaryRetrieveResponse>(getSupportTicketsSummaryRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSupportTicketsSummaryRetrieveQueryKey = () => {
    return [
    `/api/v1/support/tickets/summary/`
    ] as const;
    }

    
export const getSupportTicketsSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportTicketsSummaryRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>> = ({ signal }) => supportTicketsSummaryRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportTicketsSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>>
export type SupportTicketsSummaryRetrieveQueryError = unknown


export function useSupportTicketsSummaryRetrieve<TData = Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportTicketsSummaryRetrieve<TData = Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportTicketsSummaryRetrieve<TData = Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSupportTicketsSummaryRetrieve<TData = Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportTicketsSummaryRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




